import * as React from 'react';

interface IOptionalAnchorProps {
  href?: string;
  className?: string;
  onAnchorClick?(e: React.MouseEvent<HTMLAnchorElement>): void;
  children?: React.ReactNode;
}

export function OptionalAnchor(props: IOptionalAnchorProps) {
  const { href, onAnchorClick, ...elementProps } = props;

  if (!href) {
    return <span {...elementProps} />;
  }

  // eslint-disable-next-line react/jsx-no-target-blank
  return (
    <object>
      <a {...elementProps} href={href} rel="noopener noreferrer" target="_blank" onClick={onAnchorClick} />
    </object>
  );
}
